/**
 * Форматирование скалярных значений для readonly и input[type=date].
 * Общий слой для runtime-карточек (ОИ / РД / будущие модули).
 */

/** Текст только для чтения в карточке */
export function formatReadonlyScalar(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}

/** Значение для input type="date" из API (строка ISO или Date). */
export function toDateInputString(value: unknown): string {
  if (value == null) return "";
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  return s;
}

/** Поля, которые в сетке карточки занимают две колонки на md+. */
export function isWideCardFieldType(fieldType: string): boolean {
  return fieldType === "text" || fieldType === "json";
}
